<template>
    <div class="index">
        <div ref="conright" class="top">
            <el-carousel :height="imgHeight + 'px'">
                <el-carousel-item
                    v-for="(item, index) in lunboList"
                    :key="'a' + index"
                >
                    <img
                        :src="httpUrl + '/disk/' + item.filePath"
                        class="swiper-img"
                        alt=""
                        srcset=""
                    />
                </el-carousel-item>
            </el-carousel>
            <div class="nav-box" style="width:1240px;">
                <img
                    src="../assets/images/logo-second.png"
                    class="logo"
                    alt=""
                    srcset=""
                />
                <!-- <div class="nav">
                    <p style="color: #4ca3ff" @click="linkTo('/index')">首页</p>
                    <p @click="linkTo('/businessIntroduce')">业务介绍</p>
                    <p @click="linkTo('/productCenter')">产品中心</p>
                    <p @click="linkTo('/newstendency')">新闻动态</p>
                    <p>
                        <el-dropdown trigger="click" @command="handleCommand">
                            <span class="el-dropdown-link">
                                关于我们
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item><span @click="linkTo('/companyInfo')">企业信息</span></el-dropdown-item>
                                <el-dropdown-item><span @click="linkTo('/cooperation')">加盟合作</span></el-dropdown-item>
                                <el-dropdown-item command="/recruitInfo"><span @click="linkTo('/recruitInfo')">招聘信息</span></el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </p>
                </div> -->
                <div class="nav">
                    <div class="item" style="color:#33BBFF" @click="linkTo('/index')" >首页</div>
                    <div class="item" :class="path == '/businessIntroduce' ? 'active' : ''" @click="linkTo('/businessIntroduce')">业务介绍</div>
                    <div class="item" :class="path == '/productCenter' ? 'active' : ''" @click="linkTo('/productCenter')">产品中心</div>
                    <div class="item" :class="path == '/newstendency' ? 'active' : ''" @click="linkTo('/newstendency')">新闻状态</div>
                    <div class="item item-about" :class="
                        path == '/aboutUs' ? 'active' : ''|| 
                        path == '/companyInfo' ? 'active' : ''|| 
                        path == '/cooperation' ? 'active' : ''|| 
                        path == '/recruitInfo' ? 'active' : '' 
                    ">
                        <p @click="linkTo('/aboutUs')">关于我们</p>
                        <div class="second">
                            <p @click="linkTo('/companyInfo')">企业信息</p>
                            <p @click="linkTo('/cooperation')">加盟合作</p>
                            <!-- <p @click="linkTo('/recruitInfo')">招聘信息</p> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="business">
            <!-- <img src="../assets/images/business.png" class="bg" alt="" srcset="" /> -->
            <div class="width con">
                <div class="title">
                    <img
                        src="../assets/images/business-title.png"
                        alt=""
                        srcset=""
                    />
                    <p>主营业务</p>
                </div>
                <div class="box">
                    <div
                        class="one"
                        v-for="(item, index) in businessList"
                        :key="'b' + index"
                    >
                        <div class="img-box">
                            <img
                                :src="httpUrl + '/disk/' + item.filePath"
                                class="cover"
                                alt=""
                                srcset=""
                            />
                            <div class="title-box">
                                <div class="title-name">{{ item.busName }}</div>
                            </div>
                        </div>
                        <p
                            :ref="`list${index}`"
                            :class="item.after ? 'over' : ''"
                        >
                            {{ item.busSynopsis }}
                        </p>
                        <div class="icon-box">
                            <div
                                v-for="(item1, index1) in item.filePathList"
                                :key="'c' + index1"
                            >
                                <img
                                    :src="httpUrl + '/disk/' + item1"
                                    alt=""
                                    srcset=""
                                />
                            </div>
                        </div>
                        <!-- <img :src="item.tip" class="tips-img" alt="" srcset="" /> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="dynamic">
            <!-- <img
                src="../assets/images/dynamic.png"
                class="bg"
                alt=""
                srcset=""
            /> -->
            <div class="width con">
                <div class="title">
                    <img
                        src="../assets/images/dynamic-title.png"
                        alt=""
                        srcset=""
                    />
                    <p>公司动态</p>
                </div>
                    <div class="line-bg1" style="margin-top:4.2%"></div>
                    <div class="box">
                        <div
                            class="one"
                            v-for="(item, index) in dynamicList"
                            :key="'d' + index"
                        >
                            <p class="group">{{ item.name }}</p>
                            <!-- <img
                                :src="httpUrl + '/disk/' + item.articleCover"
                                class="cover"
                                alt=""
                                srcset=""
                            /> -->
                            <img
                                src="../assets/images/dynamic_1.jpg"
                                v-if="index==0"
                                class="cover"
                                alt=""
                                srcset=""
                            />
                            <img
                                src="../assets/images/dynamic_2.jpg"
                                v-if="index==1"
                                class="cover"
                                alt=""
                                srcset=""
                            />
                            <p class="abstract">{{ item.title }}</p>
                            <p class="introduce" v-html="item.content"></p>
                            <!-- <p
                                class="introduce"
                                :ref="`dynamic${index}`"
                                :class="item.after ? 'over' : ''"
                            >
                                {{ item.content }}
                            </p> -->
                            <p class="btn" @click="linkTo2('/newsDetail',item.id)">查看更多 >></p>
                        </div>
                    </div>
                    <div class="line-bg1" style="bottom:33.3%"></div>
            </div>
        </div>
        <div class="cooperation">
            <img
                src="../assets/images/cooperation.png"
                class="bg"
                alt=""
                srcset=""
            />
            <div class="width con">
                <div class="title">
                    <img
                        src="../assets/images/dynamic-title.png"
                        alt=""
                        srcset=""
                    />
                    <p>合作用户</p>
                </div>
            </div>
            <img
                :src="httpUrl + '/disk/' + cooperImg"
                class="width pos"
                alt=""
                srcset=""
            />
        </div>
        <footerCom></footerCom>
    </div>
</template>
<script>
import {
    busList,
    rotaList,
    cooperList,
    articleList,
    proList,
} from "../api/home.js";
import footerCom from "../components/Footer";
export default {
    name: "Index",
    components: {
        footerCom,
    },
    data() {
        return {
            httpUrl: process.env.VUE_APP_URL,
            imgHeight: 400,
            businessList: [],
            dynamicList: [{ title: ""}, { title: "" }],
            activeIndex: "1",
            lunboList: [],
            cooperImg: "",
        };
    },
    created() {
        this.businessFun();
        this.cooperListFun();
        // this.dynamicFun();
    },
    methods: {
        // 跳转
        linkTo(path){
            this.$router.push({
                path: path,
                /* query: {
                    
                }, */
            });
        },
        linkTo2(path,id){
            this.$router.push({
                path: path,
                query: {
                   id: id
                }, 
            });
        },
        // el下拉点击事件
        handleCommand(command) {
        this.$router.push({
                path: command,
                /* query: {
                    
                }, */
            });
      },
        // 轮播图
        lunboFun() {
            rotaList().then((res) => {
                if (res.code == 200) {
                    this.lunboList = res.data;
                }
            });
        },
        //业务
        businessFun() {
            busList().then((res) => {
                if (res.code == 200) {
                    this.businessList = res.data;
                    let that = this;
                    for (let i = 0; i < that.businessList.length; i++) {
                        that.businessList[i].filePathList = [];
                        that.businessList[i].filePathList =
                            that.businessList[i].filesPaths.split(",");
                    }
                }
            });
            this.$nextTick(function () {
                for (let i in this.businessList) {
                    // console.log(this.$refs[`list${i}`]);
                    let list1 = this.$refs[`list${i}`][0];
                    if (list1.scrollHeight > 80) {
                        this.businessList[i].after = true;
                    }
                }
            });
        },
        //公司动态
        dynamicFun() {
            let _this = this;
            proList().then((res) => {
                if (res.code == 200) {
                    for (let i = 0; i < res.data.length; i++) {
                        _this.dynamicList[i].name = res.data[i].name;
                        _this.dynamicList[i].descn = res.data[i].descn;
                        articleList({ programaId: res.data[i].id }).then(
                            (res2) => {
                                if (res2.code == 200) {
                                    _this.dynamicList[i].title =
                                        res2.data[0].title;
                                    _this.dynamicList[i].articleCover =
                                        res2.data[0].articleCover;
                                    _this.dynamicList[i].id = res2.data[0].id;
                                    _this.dynamicList[i].content = res2.data[0].content;

                                }
                            }
                        );
                    }
                }
            });
            this.$nextTick(function () {
                for (let i in this.dynamicList) {
                    // console.log(this.$refs[`list${i}`]);
                    let list1 = this.$refs[`dynamic${i}`][0];
                    if (list1.scrollHeight > 80) {
                        this.dynamicList[i].after = true;
                    }
                }
            });
        },
        // 合作
        cooperListFun() {
            cooperList().then((res) => {
                if (res.code == 200) {
                    this.cooperImg = res.data[0].filePath;
                }
            });
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.dynamicFun();
        });
        this.lunboFun();
        console.log(this.$refs.conright.offsetWidth);
        this.imgHeight = this.$refs.conright.offsetWidth / 2;
    },
    watch: {
        dynamicList: {
            handler(newVal) {
                console.log("变得", newVal);
                // this.dynamicFun();
            },
            deep: true,
        },
    },
};
</script>
<style lang="less" scoped>
.line-bg1{
    width: 100%;
    // min-width: 1213px;
    height: 6px;
    background:  url("../assets/images/line.png");
    background-size: 100% 100%;
    position: absolute;
}
.index {
    .top {
        position: relative;
        .swiper-img {
            width: 100%;
            height: 100%;
            display: block;
        }
        .nav-box {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            -webkit-transform: translateX(-50%); /* for Chrome || Safari */
            -moz-transform: translateX(-50%); /* for Firefox */
            -ms-transform: translateX(-50%); /* for IE */
            -o-transform: translateX(-50%); /* for Opera */
            height: 129px;
            z-index: 2000;
            // padding-left: 20px;
            display: flex;
            justify-content: space-between;
            // padding-right: 50px;
            .logo {
                height: 79px;
                width: 181px;
                display: block;
                float: left;
                margin-top: 35px;
            }
            color: #cccccc;
            font-size: 16px;
            // .nav {
            //     float: right;
            //     height: 25px;
            //     line-height: 25px;
            //     margin-top: 15px;
            //     cursor: pointer;
            //     p {
            //         float: left;
            //         padding: 0 50px;
            //         &:hover {
            //             color: #4ca3ff;
            //         }
            //     }
            // }
            .nav {
            float: right;
            cursor: pointer;
            height: 129px;
            line-height: 98px;
            .item{
                float: left;
                font-size: 22px;
                color: #ffffff;
                padding:31px 50px 0;
                position: relative;
                &.active{
                    color: #2E4C8C;
                    &::after{
                        content: '';
                        display: block;
                        width: 88px;
                        height: 4.5px;
                        background: #2E4C8C;
                        position: absolute;
                        bottom: 0;
                        left: 50px;
                    }
                }
                .second{
                    display: none;
                    line-height: 60px;
                    padding:10px 0;
                }
                &.item-about{
                    &:hover{
                        background: rgba(52,81,151,.49);
                        color: #ffffff;
                        padding:0 40px;
                        margin:0 10px;
                        p{
                            border-bottom:5px #F7F7F7 solid;
                            padding-top:36.5px;
                            line-height: 88px;
                        }
                        .second{
                            display: block;
                            p{
                                border:0;
                                font-size: 20px;
                                line-height: 46px;
                                padding:0;
                            }
                        }
                    }
                }
            }
        }
        }
    }
    .business {
        position: relative;
        background: url("../assets/images/business.png");
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        .bg {
            // min-height: 670px;
        }
        .con {
            // position: absolute;
            // top: 0;
            // left: 50%;
            margin: 0 auto;
            // transform: translateX(-50%);
            // -webkit-transform: translateX(-50%); /* for Chrome || Safari */
            // -moz-transform: translateX(-50%); /* for Firefox */
            // -ms-transform: translateX(-50%); /* for IE */
            // -o-transform: translateX(-50%); /* for Opera */
            .title {
                width: 22.76%;
                min-width: 400px;
                position: relative;
                margin: 2% auto 3%;
                p {
                    position: absolute;
                    // width: 100%;
                    // text-align: center;
                    font-size: 24px;
                    color: #fff;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    -webkit-transform: translate(
                        -50%,
                        -50%
                    ); /* for Chrome || Safari */
                    -moz-transform: translate(-50%, -50%); /* for Firefox */
                    -ms-transform: translate(-50%, -50%); /* for IE */
                    -o-transform: translate(-50%, -50%); /* for Opera */
                }
            }
            .box {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                .one {
                    width: calc(33% - 26px);
                    border: 1px solid rgba(0, 132, 255, 1);
                    color: #99c9ff;
                    font-size: 14px;
                    padding: 10px 10px;
                    margin-bottom: 26px;
                    .img-box {
                        position: relative;
                        img {
                            width: 100%;
                        }
                        .title-box {
                            width: 100%;
                            height: 100%;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            position: absolute;
                            top: 0;
                            .title-name {
                                height: 60px;
                                border: 1px #b8daff solid;
                                line-height: 60px;
                                text-align: center;
                                font-size: 20px;
                                color: #e4f1ff;
                                width: 60%;
                            }
                        }
                    }
                    p {
                        margin-top: 20px;
                        padding: 0 9%;
                        margin-bottom: 40px;
                        height: 104px;
                        line-height: 26px;
                        overflow: hidden;
                        position: relative;
                        text-align: left;
                    }
                    .icon-box {
                        display: flex;
                        justify-content: center;
                        height: 50px;
                        width: auto;
                        margin: 0 auto 38px;
                        div {
                            margin: 0 10px;
                        }
                    }
                    // .tips-img {
                    //   // height: 50px;
                    //   // width: 74%;
                    //   height: 50px;
                    //   width: auto;
                    //   margin: 0 auto 38px;
                    // }
                }
                .one:last-child {
                    margin-right: 0;
                }
            }
        }
    }
    .dynamic {
        position: relative;
         background: url("../assets/images/dynamic.png");
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        padding-bottom:79px;
        .bg {
            // min-height: 700px;
        }
        .con {
            position: relative;
            // position: absolute;
            // top: 0;
            // left: 50%;
            // transform: translateX(-50%);
            // -webkit-transform: translateX(-50%); /* for Chrome || Safari */
            // -moz-transform: translateX(-50%); /* for Firefox */
            // -ms-transform: translateX(-50%); /* for IE */
            // -o-transform: translateX(-50%); /* for Opera */
            .title {
                width: 22.76%;
                min-width: 400px;
                position: relative;
                margin: 2% auto 6%;
                p {
                    position: absolute;
                    // width: 100%;
                    // text-align: center;
                    font-size: 24px;
                    color: #fff;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    -webkit-transform: translate(
                        -50%,
                        -50%
                    ); /* for Chrome || Safari */
                    -moz-transform: translate(-50%, -50%); /* for Firefox */
                    -ms-transform: translate(-50%, -50%); /* for IE */
                    -o-transform: translate(-50%, -50%); /* for Opera */
                }
            }
            .box {
                position: relative;
                .one {
                    width: calc(49% - 56px);
                    color: #99c9ff;
                    font-size: 14px;
                    padding: 8px 9px;
                    float: left;
                    margin-right: 130px;
                    .group {
                        color: #dff1ff;
                        font-size: 32px;
                        height: 1em;
                        line-height: 1em;
                    }
                    .cover {
                        margin-top: 12%;
                        margin-bottom: 15%;
                        max-height: 220px;
                    }
                    .abstract {
                        font-size: 20px;
                        color: #fff;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        width: 100%;
                    }
                    .introduce {
                        margin-top: 30px;
                        font-size: 16px;
                        height: 63px;
                        overflow: hidden;
                    }
                    .btn {
                        width: 155px;
                        text-align: center;
                        height: 47px;
                        line-height: 47px;
                        color: #0091ff;
                        font-size: 18px;
                        border: 1px solid rgba(0, 164, 255, 1);
                        margin: 60px auto 0;
                        cursor: pointer;
                    }
                }
                .one:last-child {
                    margin-right: 0;
                }
            }
        }
    }
    .cooperation {
        position: relative;
        .bg {
            // min-height: 700px;
        }
        .con {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            -webkit-transform: translateX(-50%); /* for Chrome || Safari */
            -moz-transform: translateX(-50%); /* for Firefox */
            -ms-transform: translateX(-50%); /* for IE */
            -o-transform: translateX(-50%); /* for Opera */
            .title {
                width: 22.76%;
                min-width: 400px;
                position: relative;
                margin: 6% auto 6%;
                p {
                    position: absolute;
                    // width: 100%;
                    // text-align: center;
                    font-size: 24px;
                    color: #fff;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    -webkit-transform: translate(
                        -50%,
                        -50%
                    ); /* for Chrome || Safari */
                    -moz-transform: translate(-50%, -50%); /* for Firefox */
                    -ms-transform: translate(-50%, -50%); /* for IE */
                    -o-transform: translate(-50%, -50%); /* for Opera */
                }
            }
        }
        .pos {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            -webkit-transform: translate(-50%, -50%); /* for Chrome || Safari */
            -moz-transform: translate(-50%, -50%); /* for Firefox */
            -ms-transform: translate(-50%, -50%); /* for IE */
            -o-transform: translate(-50%, -50%); /* for Opera */
            margin: 50px 0;
        }
    }
}

/deep/ .el-carousel__indicators--horizontal {
    display: none;
}
@media screen and (max-width: 1750px) {
    .index .business .con .box .one .tips-img {
        height: 40px;
    }
    .index .business .con .box .one p {
        margin-bottom: 56px;
    }
    .index .dynamic .con .title {
        margin: 2% auto 4.4%;
    }

    .index .dynamic .con .box .one .cover {
        margin-top: 9%;
    }
    // .index .dynamic .con .box .one {
    //     width: 30%;
    //     margin-right: 5%;
    // }
}
@media screen and (max-width: 1600px) {
    .index .dynamic .con .title {
        margin: 2% auto 3.5%;
    }
    .index .dynamic .con .box .one .cover {
        margin-top: 10%;
    }
    .index .dynamic .con .box .one .introduce {
        margin-top: 25px;
    }
    .index .dynamic .con .box .one .btn {
        margin: 50px auto 0;
        height: 42px;
        line-height: 42px;
    }
}
@media screen and (max-width: 1550px) {
    .index .dynamic .con .title {
        margin: 2% auto 2.6%;
    }
    // .index .dynamic .con .box .one {
    //     width: 30%;
    //     margin-right: 5%;
    // }
    .index .dynamic .con .box .one .btn {
        margin: 40px auto 0;
        height: 42px;
        line-height: 42px;
    }
}
@media screen and (max-width: 1455px) {
    .index .business .con .box .one .tips-img {
        height: 35px;
    }
    .index .dynamic .con .title {
        margin: 2% auto 2%;
    }
    .index .dynamic .con .box .one .group {
        font-size: 28px;
    }
}
@media screen and (max-width: 1400px) {
    .index .dynamic .con .box .one .btn {
        margin: 35px auto 0;
        height: 38px;
        line-height: 38px;
        font-size: 16px;
    }
}

@media screen and (max-width: 1350px) {
    .index .business .con .box .one .tips-img {
        height: 30px;
    }
    .index .business .con .box .one p {
        margin-bottom: 40px;
    }
    .index .dynamic .con .title {
        margin: 2% auto 1%;
        font-size: 26px;
    }
}
@media screen and (max-width: 1300px) {
    .index .dynamic .con .box .one .btn {
        margin: 35px auto 0;
        height: 38px;
        line-height: 38px;
        font-size: 16px;
    }
    .index .dynamic .con .title {
        font-size: 26px;
    }
    .index .dynamic .con .box .one .introduce {
        margin-top: 18px;
    }
}
</style>

<style>
.el-popper .popper__arrow::after {
    content: none;
}
.el-popper[x-placement^="bottom"] {
    margin-top: 0;
    margin-right: -15px;
    /* padding: 0 20px; */
}
.el-popper[x-placement^="bottom"] .popper__arrow {
    display: none;
}
.el-dropdown-menu {
    position: absolute;
    top: 0;
    left: 0;
    padding: 10px 0;
    margin: 0;
    background-color: rgba(0, 0, 0, 0.3);
    border: none;
    border-radius: 0;
    box-shadow: none;
}
.el-dropdown-menu__item {
    color: #ccc;
    width: 110px;
    text-align: center;
    background-color: rgba(0, 0, 0, 0) !important;
}
.el-dropdown-menu__item:hover {
    background-color: rgba(0, 0, 0, 0);
}
.el-dropdown-menu__item:focus {
    background-color: rgba(0, 0, 0, 0);
}
.el-dropdown {
    color: #ccc;
    font-size: 16px;
}
</style>